<template>
  <b-row class= 'group-link'>
    <b-col cols=12>
      <b-row v-if='titulo !== ""' class="titulo">
        <h5>{{titulo}}</h5>
      </b-row>
      <b-row class="texto">
        <b-col cols=12 style="padding-right: 40px;">
          <p>{{valor}}</p>
          <input type="hidden" ref="testingCode" :value="valor">
        </b-col>
        <b-col cols=12 class='icon'>
          <img
          class=""
          @click.stop.prevent="copiar"
          :src="require('../../assets/copiar-icon.svg')"
          style="height: auto; width: 20px; margin-top: 10px; "/>
          <span :class="['copy-icon-message', this.copiado ?'show':'']" aria-hidden="true" style="top: 3px;">Copiado!</span>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    titulo: {
      type: String,
      required: true,
      default: 'dsds'
    },
    valor: {
      type: String,
      required: true,
      default: 'sdsd'
    }
  },
  data () {
    return {
      copiado: false
    }
  },
  methods: {
    /**/
    copiar (e) {
      console.log('copiado')
      const testingCodeToCopy = this.$refs.testingCode // document.querySelector('.group-link #testing-code')
      testingCodeToCopy.setAttribute('type', 'text') // hidden
      testingCodeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        console.log('copiar ' + msg)
      } catch (err) {
        console.log('Oops, unable to copy')
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()

      this.copiado = true
      const interval = setInterval(() => {
        this.copiado = false
        clearInterval(interval)
      }, 500)
    }
  }
}
</script>
<style scoped>
  .group-link p {
    display: block;
    /*padding: 5px 10px 5px 5px;*/
    text-decoration: none;

    font-family: Poppins-Light;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 126%;
    text-align: right;
    color: #FFFFFF;
  }
  .group-link .titulo h5{

    font-style: normal;
    font-weight: 500;
    /* font-size: 12px; */
    line-height: 126%;
    text-align: center;
    /* color: #FFFFFF; */
    margin-bottom: 5px;
  }
  .group-link .texto{
    position: relative;
    background-color: #343434;
    border-radius: 7px;
    padding-top: 10px;
  }
  .group-link .texto p{
    text-align: left;
    margin-bottom: 8px;
    max-width: 350px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .group-link .icon{
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    text-align: right;
  }
  .copy-icon-message {
    background: #212121;
    border-radius: 6px;
    color: #fff;
    display: none;
    font-size: .9rem;
    opacity: 1;
    padding: 6px;
    position: absolute;
    right: 8px;
    top: 15px;
    z-index: 100;
  }
  .copy-icon-message.show{
    display: block;
  }
</style>
